<div class="custom-scrollbar" [class.sample-analysis-panel--collapsed]="collapsed">
  <div class="flex-row justify-content-around analysis-context-selection">
    <div class="analysis-context-selection__option" [class.active]="analysisContext === Context.Asset"
      (click)="onToggleContext(Context.Asset)" data-cy="toggle-asset-tasks">
      <i class="ri-image-line"></i>
      {{ 'core.assettype.image' | translate | uppercase }}
    </div>
    <div class="analysis-context-selection__option" [class.active]="analysisContext === Context.Sample"
      (click)="onToggleContext(Context.Sample)" data-cy="toggle-sample-tasks">
      <i class="ri-grid-line"></i>
      {{ 'core.sample' | translate | uppercase }}
    </div>
  </div>
  <!-- Counting controls are analysis-only; hidden for technicians. -->
  <ng-container *ngIfRole="['admin', 'analyst', 'analystmanager']">
    <div class="panel-controls-bar" *ngIf="analysisContext === Context.Asset && (taggingProtocol || segmentation)">
      <div class="total-count-text" *ngIf="totalCount !== undefined && totalCount !== null">
        <span>{{ 'label.total_count' | translate }}: {{ totalObjectsCount ?? totalCount }}</span>
        <ng-container *ngIf="totalObjectsCount !== null">
          <span class="total-count-text__separator"> | </span>
          <span>{{ 'label.det_activas' | translate }}: {{ totalCount }}</span>
        </ng-container>
      </div>
      <div class="panel-header-controls">
        <div class="counter-mode-selector">
          <button mat-icon-button class="counter-mode-button" [matMenuTriggerFor]="statsModeMenu"
            [matTooltip]="'button.menu.settings' | translate" [matTooltipShowDelay]="1000"
            #statsModeTooltip="matTooltip" (mouseleave)="statsModeTooltip.hide()" data-cy="button-stats-mode">
            <i [ngClass]="{
              'ri-discount-percent-line': statsMode === StatsMode.SELECTIVE,
              'ri-water-percent-line': statsMode === StatsMode.COMPLETE
            }"></i>
          </button>
          <mat-menu #statsModeMenu="matMenu" class="widget">
            <ts-stats-settings [statsMode]="statsMode"
              (statsModeChanged)="setStatsMode.emit($event)"></ts-stats-settings>
          </mat-menu>
        </div>
        <div class="toggle-buttons">
          <button mat-icon-button class="toggle-icon-button" [class.active]="showPinned"
            [matTooltip]="'tooltip.display_favourite_models' | translate" [matTooltipShowDelay]="1000"
            #pinnedTooltip="matTooltip" (mouseleave)="pinnedTooltip.hide()" (click)="tooglePinned.emit()"
            data-cy="toggle-pinned-models">
            <i class="ri-pushpin-line" [ngClass]="{ 'ri-pushpin-fill': showPinned }"></i>
          </button>
          <button *ngIf="taggingProtocol" mat-icon-button class="toggle-icon-button" [class.active]="multiSelection"
            [disabled]="!canEdit || forceExpanded" [matTooltip]="'tooltip.multi_model_rois' | translate"
            [matTooltipShowDelay]="1000" #multiTooltip="matTooltip" (mouseleave)="multiTooltip.hide()"
            (click)="toggleMulti.emit()" data-cy="toggle-multi-models">
            <i class="ri-checkbox-multiple-line" [ngClass]="{ 'ri-checkbox-multiple-fill': multiSelection }"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Projection slot for the label-selection panel: sits between the controls
       bar and the analysis expansion panels. Styled (scoped) to blend into the
       panel — see .label-selection-slot in the scss. Hidden for non-analysis
       roles: a technician only edits acquisition data. -->
  <div class="label-selection-slot" *ngIfRole="['admin', 'analyst', 'analystmanager']">
    <ng-content select="[labelSelection]"></ng-content>
  </div>

  <mat-expansion-panel class="custom-mat-expansion-panel analysis-expansion-panel" [expanded]="expanded">
    <div *ngIf="analysisContext === Context.Asset && pipelines.length && stitchingScans" analysisPanelHeader>
      <div class="options-panel__item flex-row align-items-center">
        <span class="flex-grow-1"> {{ 'core.num_images' | translate }}: {{ stitchingScans }} </span>
      </div>
    </div>
    <ng-container *ngIf="!loadingProtocol">
      <ng-container
        *ngIf="(selectedAsset?.data | hasKeys) && analysisContext === Context.Asset && acquisitionFields?.length">
        <mat-expansion-panel [expanded]="true" class="custom-mat-expansion-panel acquisition-data-expansion-panel">
          <mat-expansion-panel-header><mat-panel-title class="flex-row justify-content-between">
              <h4 [attr.data-cy]="'acquisition-data'">
                {{ 'title.acquisition_data' | translate }}
              </h4>
            </mat-panel-title></mat-expansion-panel-header>
          <ts-acquisition-data [acquisitionData]="selectedAsset.data" [assetFields]="acquisitionFields"
            [isEditable]="dataEditable" [editMode]="acquisitionEdition" (saveData)="saveAssetData.emit()"
            (discardChanges)="discardDataChanges.emit($event)" (editionMode)="acquisitionEditionMode.emit($event)"
            (fieldChange)="onAcquisitionFieldChange($event)"></ts-acquisition-data>
        </mat-expansion-panel>
      </ng-container>
      <!-- Protocol pipelines/labels are analysis-only; hidden for a technician,
           who edits only the acquisition data above. -->
      <ng-container *ngIfRole="['admin', 'analyst', 'analystmanager']">
        <ng-container *ngIf="pipelines.length > 0; else noProtocol">
          <mat-expansion-panel class="custom-mat-expansion-panel analysis-type-expansion-panel"
            *ngFor="let pipeline of pipelines; trackBy: trackByPipelineId" [expanded]="true">
            <mat-expansion-panel-header class="analysis-expansion-panel-header">
              <mat-panel-title class="flex-row justify-content-between">
                <h4 [attr.data-cy]="'analysis_type_name_' + pipeline.names.en">
                  {{ pipeline.names.en }}
                </h4>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="hasTaggingCategories(pipeline)" class="protocol-classification-header"
              [attr.data-cy]="'protocol-classification-header'">
              <div class="protocol-classification-header__row protocol-classification-header__row--main">
                <span class="protocol-classification-header__cell protocol-classification-header__cell--label"></span>
                <span class="protocol-classification-header__cell protocol-classification-header__cell--image-span">{{
                  'label.counter_header_image' | translate }}</span>
                <span class="protocol-classification-header__cell protocol-classification-header__cell--sample-span">{{
                  'label.counter_header_sample' | translate }}</span>
              </div>
              <div class="protocol-classification-header__row protocol-classification-header__row--sub">
                <span class="protocol-classification-header__cell protocol-classification-header__cell--label"></span>
                <span class="protocol-classification-header__cell protocol-classification-header__cell--shaded">{{
                  'label.counter_header_count' | translate }}</span>
                <span class="protocol-classification-header__cell protocol-classification-header__cell--shaded">%</span>
                <span class="protocol-classification-header__cell protocol-classification-header__cell--shaded">{{
                  'label.counter_header_count' | translate }}</span>
                <span class="protocol-classification-header__cell protocol-classification-header__cell--shaded">%</span>
              </div>
            </div>

            <ts-protocol-panel class="sample-analysis-panel__unified-protocol-panel"
              [sectionTemplate]="sampleProtocolSection" [labelTemplate]="sampleProtocolLabel"
              [pipelines]="asAnalysisTypeProtocolPipelines(pipeline)" [categories]="protocolPanelDisplayCategoriesById"
              [options]="protocolPanelDisplayOptionsById" [collapsed]="collapsed" [loading]="false"
              (labelSelected)="onUnifiedProtocolLabelSelected($event)"></ts-protocol-panel>
          </mat-expansion-panel>
        </ng-container>
      </ng-container>
      <ng-template #noProtocol>
        <div class="text-secondary" style="text-align: center; margin: 20px">
          <i class="ri-alert-line"></i>
          <!-- REVIEW: message is displayed also while loading -->
          {{ 'alert.no_protocol_in_this_context' | translate }}
        </div>
      </ng-template>
    </ng-container>
  </mat-expansion-panel>

  <ng-template #sampleProtocolSection let-category>
    <ng-container [ngSwitch]="protocolSectionKind(category)">
      <ng-container *ngSwitchCase="'tagging'">
        <ts-micro-protocol-header [categoryId]="category.id" [collapsed]="collapsedCategories.has(category.id)"
          [title]="steps[category.stepId]?.allowNewOptions ? ('label.custom_labels' | translate) : category.name"
          [assetTotalCount]="getRoiAssetCategoryTotalCount(category)"
          [assetTotalPct]="getRoiAssetCategoryTotalPercentage(category)"
          [sampleTotalCount]="getRoiSampleCategoryTotalCount(category)"
          [sampleTotalPct]="getRoiSampleCategoryTotalPercentage(category)"
          [showAddLabel]="!!steps[category.stepId]?.allowNewOptions"></ts-micro-protocol-header>
      </ng-container>
      <ng-container *ngSwitchCase="'segmentation'">
        <span class="sample-protocol-segmentation-title">{{
          steps[category.stepId]?.allowNewOptions ? ('label.custom_labels' | translate) : category.name
          }}</span>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <span class="sample-protocol-analysis-title">{{ category.name }}</span>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #sampleProtocolLabel let-data>
    <ng-container [ngSwitch]="protocolLabelKind(data.category)">
      <ng-container *ngSwitchCase="'tagging'">
        <ts-micro-protocol-cell *ngIf="data.label" (mouseenter)="onLabelHover(data.label.id)"
          (mouseleave)="onLabelHoverEnd()" [collapsed]="collapsed" [label]="data.label"
          [pipelineId]="getPipelineIdForCategory(data.category.id)" [multiSelection]="multiSelection"
          [canEdit]="canEdit" [hasSelectedRois]="hasSelectedRois" [excludedFromCounter]="excludedFromCounter"
          [pinnedLabels]="pinnedLabels" [visibleLabels]="visibleLabels"
          [labelsInAllSelectedRois]="labelsInAllSelectedRois" [labelsInSomeSelectedRois]="labelsInSomeSelectedRois"
          [selectedLabels]="selectedLabels" [displayAssetCount]="getRoiDisplayAssetRoiCount(data.label.id)"
          [assetPctDisplay]="getRoiAssetRoiPercentageDisplay(data.label.id)"
          [displaySampleCount]="getRoiDisplaySampleRoiCount(data.label.id)"
          [samplePctDisplay]="getRoiSampleRoiPercentageDisplay(data.label.id)" (selectLabel)="selectLabel.emit($event)"
          (counterLabel)="counterLabel.emit($event)" (pinLabel)="pinLabel.emit($event)"
          (visibleLabel)="visibleLabel.emit($event)"></ts-micro-protocol-cell>
      </ng-container>

      <ng-container *ngSwitchCase="'segmentation'">
        <ts-segmentation-protocol-cell *ngIf="data.label as option" (mouseenter)="onLabelHover(option.id)"
          (mouseleave)="onLabelHoverEnd()" [label]="option" [canEdit]="canEdit"
          [checked]="isSegmentationLabelChecked(option.id)" [pinned]="pinnedLabels.has(option.id)"
          (selectLabel)="selectLabel.emit($event)" (pinLabel)="pinLabel.emit($event)"></ts-segmentation-protocol-cell>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <ng-container *ngIf="protocolCategoriesById[data.category.id] as analysisCategory">
          <div *ngIf="isAnalysisInputAnchorRow(data.category, data.label.id)" (click)="$event.stopPropagation()">
            <ts-analysis-input [category]="analysisCategory" [options]="options" [steps]="steps"
              [finding]="getActiveFinding(analysisCategory.stepId)" [collapsedCategories]="collapsedCategories"
              [pipelineId]="getPipelineIdForCategory(analysisCategory.id)" [isViewMode]="!canEdit" [embedded]="true"
              (updateFinding)="onUpdateFinding($event)" (createFinding)="onCreateFinding($event)"></ts-analysis-input>
          </div>
          <div *ngIf="isProtocolRowPlaceholder(data.category, data.label.id)"
            class="sample-analysis-panel__protocol-row-skip"></div>
          <div *ngIf="isProtocolAnalysisFallbackRow(data.category, data.label.id)"
            class="sample-protocol-unsupported text-secondary">
            {{ data.category.stepTask }}: {{ 'label.option_not_supported' | translate }}
          </div>
          <div *ngIf="isProtocolAnalysisSkipOnlyRow(data.category, data.label.id)"
            class="sample-analysis-panel__protocol-row-skip"></div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>